import { Card } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { useCustomerValue } from "providers/CustomerContext";
import { useState } from "react";
import { Link } from "react-router-dom";
import { getInventoryLocationList } from "services/data.inventory.service";
import { getInventorySKUList } from "services/data.inventory.service";
import { Error_ } from "ui-components/Alert";
import { LoadingDialog } from "ui-components/Alert";
import { ListLayout } from "ui-components/Layout";
import BasicTable from "ui-components/tables/BasicTable";
import ServerTable from "ui-components/tables/ServerTable";
import BasicTabs from "ui-components/tabs/BasicTabs";

const tabs = ["Stock Available", "Out of stock", "Inactive"];

function InventoryLocationList() {
  const { customerCode } = useCustomerValue();
  const columns = [
    {
      header: "Location ID",
      accessorKey: "locationID",
      cell: ({ row }) => (
        <Link
          style={{ color: "#1A73E8", fontWeight: "bold" }}
          to="/inventory/location/details"
          state={{
            customerCode,
            warehouseCode: row.original.warehouseCode,
            zoneID: row.original.zoneID,
            locationID: row.original.locationID,
          }}
        >
          <span style={{ textDecoration: "underline" }}>{row.original.locationID}</span>
        </Link>
      ),
    },
    {
      header: "Warehouse Code",
      accessorKey: "warehouseCode",
    },
    {
      header: "Zone ID",
      accessorKey: "zoneID",
    },
    {
      header: "Number of SKU",
      accessorKey: "numberOfSKU",
    },
  ];
  const [status, setStatus] = useState("Stock Available");
  const [kitType, setKitType] = useState("SINGLE");
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 });
  const [columnFilters, setColumnFilters] = useState([]);
  const [sorting, setSorting] = useState([]);
  const [alert, setAlert] = useState(null);
  const [list, setList] = useState([]);
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);
  const { isFetching } = useQuery({
    queryKey: ["inventory-list", { customerCode }],
    queryFn: () => getInventoryLocationList({ customerCode }),
    onSuccess: (data) => {
      setList(data.data.data);
    },
    enabled: Boolean(customerCode),
    onError,
  });
  const tableProps = {
    data: list,
    columns,
    // pagination,
    // setPagination,
    // columnFilters,
    // setColumnFilters,
    // sorting,
    // setSorting,
  };
  return (
    <ListLayout>
      {isFetching && <LoadingDialog />}
      <MDBox my={3}>
        {alert}
        {/* <BasicTabs tabs={tabs} status={status} setStatus={setStatus} />
        <MDBox display="flex" alignItems="flex-start" mt={2}>
          <MDButton
            sx={{ borderRadius: "5px" }}
            variant={kitType === "SINGLE" ? "gradient" : "outlined"}
            color="info"
            size="small"
            onClick={() => setKitType("SINGLE")}
          >
            Product
          </MDButton>
          <MDButton
            sx={{ marginLeft: "1rem", borderRadius: "5px" }}
            variant={kitType === "KIT" ? "gradient" : "outlined"}
            color="info"
            size="small"
            onClick={() => setKitType("KIT")}
          >
            Kit
          </MDButton>
        </MDBox> */}
      </MDBox>

      <BasicTable {...tableProps} />
    </ListLayout>
  );
}

export default InventoryLocationList;
